"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z.null();
exports.path = '/admin-get-properties';
//# sourceMappingURL=index.js.map